var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.681,
    height: 100.606,
    viewBox: "0 0 103.681 100.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}.cls-2{fill:#f8686e}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-212.319 -151.023)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M50.082 34.5a6.747 6.747 0 0 1 6.335 4.45l1.156 3.55 5.248 16.116a7.287 7.287 0 0 1-.418 5.555l-23.857 47.572a5.261 5.261 0 0 1-4.806 2.757 6.807 6.807 0 0 1-3.033-.732l-27.141-13.61a6.561 6.561 0 0 1-3.118-3.232A4.986 4.986 0 0 1 .5 92.662L24.366 45.1a7.287 7.287 0 0 1 4.2-3.656l19.6-6.628a5.967 5.967 0 0 1 1.916-.316zM33.74 112.1a2.843 2.843 0 0 0 2.656-1.433L60.253 63.1a4.9 4.9 0 0 0 .28-3.732L54.129 39.7a4.344 4.344 0 0 0-4.047-2.788 3.567 3.567 0 0 0-1.146.183l-19.6 6.628a4.895 4.895 0 0 0-2.824 2.456L2.654 93.741c-.722 1.44.171 3.354 1.99 4.267l27.142 13.613a4.39 4.39 0 0 0 1.954.479zm9.192-63.246a6.692 6.692 0 0 1 3.462 12.416 6.709 6.709 0 0 1-3.47.968 6.692 6.692 0 0 1-3.462-12.418 6.709 6.709 0 0 1 3.47-.968zm-.008 10.976a4.289 4.289 0 1 0-1.917-.456 4.267 4.267 0 0 0 1.917.456z",
    transform: "rotate(29 -99.693 578.017)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    className: "cls-2",
    transform: "rotate(-34.369 458.347 -268.182)",
    d: "M0 0h16.243v1.556H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    className: "cls-2",
    transform: "rotate(-34.367 473.802 -272.978)",
    d: "M0 0h16.243v2.658H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_116",
    "data-name": "Rectangle 116",
    className: "cls-2",
    transform: "rotate(-34.367 481.964 -275.5)",
    d: "M0 0h16.243v2.658H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_117",
    "data-name": "Rectangle 117",
    className: "cls-2",
    transform: "rotate(-34.363 488.29 -277.49)",
    d: "M0 0h16.243v4.984H0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    className: "cls-2",
    transform: "rotate(-34.363 463.8 -269.92)",
    d: "M0 0h16.243v4.984H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    className: "cls-2",
    transform: "rotate(-34.36 448.777 -265.395)",
    d: "M0 0h16.243v3.793H0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M83.609 38.472a4.616 4.616 0 0 1-2.1-.483c-2.355-1.181-3.439-4.327-3.053-8.858a40.211 40.211 0 0 1 4.326-13.974A40.218 40.218 0 0 1 91.4 3.332C94.8.312 97.971-.7 100.326.481s3.439 4.328 3.053 8.859a40.214 40.214 0 0 1-4.326 13.975 50.63 50.63 0 0 1-1.978 3.576l-2.056-1.25a47.813 47.813 0 0 0 1.883-3.4 37.788 37.788 0 0 0 4.079-13.1c.288-3.383-.36-5.815-1.734-6.5s-3.711.245-6.25 2.5a37.792 37.792 0 0 0-8.061 11.1 37.785 37.785 0 0 0-4.079 13.1c-.288 3.383.36 5.814 1.734 6.5 1.192.6 2.8-.089 3.94-.771l1.236 2.064a8.435 8.435 0 0 1-4.158 1.338z",
    transform: "rotate(29 -113.443 493.653)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_123",
    "data-name": "Rectangle 123",
    transform: "translate(218 160)",
    style: {
      fill: "none"
    },
    d: "M0 0h98v81H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.ad84210d8d223d58d33d7fa3da18988d.svg";
export { ForwardRef as ReactComponent };